module.exports = __webpack_public_path__ + "assets/img/83e638c3c2a07e6daed58866dd9daea7.svg";